import hoverLight from '../hover/light';

const light = (params) => hoverLight(params);

export default light;
